import { UserManager } from 'oidc-client-ts';

import { appConfig } from '@/common/config';

const userManager = new UserManager(appConfig.settings);

export async function getUser() {
    return await userManager.getUser();
}

export async function isAuthenticated() {
    let token = await getAccessToken();
    return !!token;
}

export async function handleOAuthCallback(callbackUrl: string) {
    try {
        return await userManager.signinRedirectCallback(callbackUrl);
    } catch (e) {
        return {
            error: true,
            message: `error while handling oauth callback: ${e}`
        }
    }
}

export async function sendOAuthRequest() {
    try {
        return await userManager.signinRedirect();
    } catch (error: any) {
        return {
            error: true,
            message: error.message
        }
    }
}

// renews token using refresh token
export async function renewToken() {
    return await userManager.signinSilent();
}

export async function getAccessToken() {
    const user = await getUser();
    return user?.access_token;
}
